import CreateGame from '../views/Game/CreateGame';
import ListGames from '../views/Game/ListGames';
import ViewResponse from '../views/Quiz/ViewResponse';
import Message from '../views/Quiz/Message';
// import Signin from '../views/Quiz/Signin';

const appRoutes = [
    
    // {path: "/login", name: "Sign In",icon: "pe-7s-user",  component: Signin},
    {path: "/create-game", name: "Create Quiz", icon: "pe-7s-magic-wand", component: CreateGame},
    {path: "/games", name: "List Quizzes", icon: "pe-7s-server", component: ListGames},  
    {path: "/responses", name: "List Responses", icon: "pe-7s-drawer", component: ViewResponse},  
    {path: "/message", name: "Final Message", icon: "pe-7s-mail", component: Message},  
    // {path: "/", to: "/dashboard", name: "Dashboard"}
];


export default appRoutes;



// WEBPACK FOOTER //
// ./src/routes/app.jsx